export * from './seo-structured-data-script';
